module.exports = __webpack_public_path__ + "static/media/cleaning_info.3f07c508.svg";